import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const StockRoute: Route = {
  path: 'stock',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/stock.component').then((m) => m.StockComponent),
    },
    {
      path: ':stockId',
      loadComponent: () => import('./pages/stock-asset.component').then((m) => m.StockAssetComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
